<template>

            <b-table
                :empty-text="this.$t('there_are_no_records')"
                bordered
                striped
                responsive
                :items="changeOfClassRequest"
                :fields="changeOfClassRequestFields"
                show-empty
                class="mb-5 table-dropdown no-scrollbar border rounded"
            >
                <template #cell(semesters)="row"><span
                    class="d-flex align-items-center">{{ row.item.semesters }}</span>
                </template>
                <template #cell(steps)="row">
                                <span class="d-flex align-items-center justify-content-center" style="cursor:pointer">
                                    <i class="ri-arrow-down-s-line"></i>
                                </span>
                </template>
                <template #row-details="data">
                    <b-table-simple responsive small class="table-bordered table-striped table-sm">
                        <thead>
                        <tr>
                            <th class="text-center">{{ $t('rank').toUpperCase() }}</th>
                            <th class="text-center">{{ $t('can_approvers').toUpperCase() }}</th>
                            <th class="text-center">{{ $t('approved_by').toUpper() }}</th>
                            <th class="text-center">{{ $t('status').toUpper() }}</th>
                            <th class="text-center">{{ $t('explanation').toUpper() }}</th>
                            <th class="text-center">{{ $t('updated_at').toUpper() }}</th>
                        </tr>
                        </thead>
                        <b-tbody v-for="(item,i) in data.item.steps" :key="i">
                            <tr>
                                <td class="text-center">{{ i + 1 }}</td>
                                <td>
                                    {{item.name}}
                                </td>

                                <td>
                                    <div v-for="(approved,i) in (getObjectValue(item,'approved',[]))" :key="i">
                                        {{
                                            getObjectValue(approved, 'name') + ' ' + getObjectValue(approved, 'surname')
                                        }}
                                    </div>
                                </td>


                                <td>{{ item.status_name }}</td>


                                <td>{{ getObjectValue(item, 'reason') }}</td>


                                <td>{{ IsoDate(item.updated_at) }}</td>
                            </tr>
                        </b-tbody>
                    </b-table-simple>
                </template>
            </b-table>
</template>
<script>
import qs from "qs";
import EslChangeOfClassRequestService from "@/services/EslChangeOfClassRequestService";
import moment from "moment/moment";

export default {
    name: "ChangeOfClassRequest",
    props:{
        filter:{
          type:Object
        }
    },
    data(){
        return {
            changeOfClassRequestFields: [
                {key: ('module_date_name'), label: this.toUpperCase('module')},
                {key: 'type', label: this.toUpperCase('type')},
                {key: 'reason', label: this.toUpperCase('reason')},
                {key: 'explanation', label: this.toUpperCase('explanation')},
                {key: 'status', label: this.toUpperCase('status')},
                {key: 'directors_note', label: this.toUpperCase('directors_note')},
                {key: 'course_name', label: this.toUpperCase('new_course')},
                {key: 'created_at', label: this.toUpperCase('created_at')},
            ],
            changeOfClassRequest: [],
        }
    },
    created() {
      this.getData()
    },
    methods:{
        IsoDate(date) {
            return moment(date).utc().format("MM/DD/YYYY HH:mm");
        },
        getData(){
            const changeOfClassRequestConfig = {
                ...this.filter,
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }

            EslChangeOfClassRequestService.getAll(changeOfClassRequestConfig)
                .then(response => {
                    this.changeOfClassRequest = response.data.data;
                }).catch(e => {
                this.showErrors(e);
            })
        }


    }
}
</script>

<style scoped>

</style>
